import { render } from "./Hcase.vue?vue&type=template&id=1f4f01dd&scoped=true"
import script from "./Hcase.vue?vue&type=script&lang=js"
export * from "./Hcase.vue?vue&type=script&lang=js"

import "./Hcase.vue?vue&type=style&index=0&id=1f4f01dd&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4f01dd"]])

export default __exports__